<div class="wrapper">
  <div class="title">{{ title() }}</div>
  <form [formGroup]="ageParamsFormGroup">
    <ng-container formArrayName="ageParams">
      @for (ageParam of ageParams.controls; track $index) {
        <div class="age-param">
          <label>{{ params()[$index].name }}</label>
          <mat-progress-bar
            class="example-margin"
            color="primary"
            mode="determinate"
            [value]="ageParam.getRawValue()"
          >
          </mat-progress-bar>
          <input
            type="number"
            [formControlName]="$index"
            (input)="handleInputEvent($event)"
          >
        </div>
      }
    </ng-container>
  </form>
</div>
